import { Locale } from 'vant'
import enUS from 'vant/es/locale/lang/en-US'

const vantLang = {
  en_US: enUS,
}

export default function setVantLang(lang?: string) {
  console.log('lang', lang)
  if (lang) {
    Locale.use(lang, vantLang[lang])
  } else {
    Locale.use('en_US', enUS)
  }
}
